import React from "react"
import { Tooltip } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useGetExperienceQuery } from "../../core/api/experience-api"
import "./XpWidget.css"
import XpIcon from "../../img/xp.svg";

export default function XpWidget() {
    const { data, isLoading, isError } = useGetExperienceQuery()
    const navigate = useNavigate()

    if (isLoading || isError || !data) {
        return (
            <div className={`xp-widget__wrapper`}>
                <div
                    className={`xp-widget`}
                    onClick={() => navigate("/experience")}
                >
                    <img src={XpIcon}/>
                    <span className="xp-widget__xp">0</span>
                </div>
            </div>
        )
    }

    const { totalXp, currentLevel, pendingRewardBelcoins, nextLevel, xpToNextLevel, progressPercent } = data
    const hasPending = pendingRewardBelcoins > 0
    const fillPercent = progressPercent === null ? 100 : Math.round(progressPercent * 100)

    let hint
    if (hasPending) {
        hint = `claim +${pendingRewardBelcoins} Belcoin`
    } else if (nextLevel) {
        hint = `${xpToNextLevel} XP to level ${nextLevel.level}`
    } else {
        hint = "max level"
    }

    const tooltip = hasPending
        ? `${totalXp} XP · unclaimed reward — open My Experience`
        : `${totalXp} XP · level ${currentLevel}`

    return (
        <Tooltip title={tooltip}>
            <div className={`xp-widget__wrapper`}>
                <div
                    className={`xp-widget${hasPending ? " xp-widget--claim" : ""}`}
                    onClick={() => navigate("/experience")}
                >
                    <img src={XpIcon}/>
                    <span className="xp-widget__xp">{totalXp}</span>
                </div>
            </div>
        </Tooltip>
    )
}
